import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDrafts = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.4545 19.1663C16.5823 19.1663 17.5 18.285 17.5 17.2021V4.76158C17.5 4.67646 17.4823 4.59134 17.4475 4.51146C17.4127 4.43092 17.363 4.3589 17.2995 4.29801L13.8918 1.02551C13.8291 0.964615 13.7534 0.916817 13.6695 0.883424C13.5864 0.850686 13.4977 0.833008 13.4091 0.833008H4.54545C3.41773 0.833008 2.5 1.71432 2.5 2.79729V17.2021C2.5 18.285 3.41773 19.1663 4.54545 19.1663H15.4545ZM14.0909 3.06837L15.1723 4.10682H14.0909V3.06837ZM3.86364 17.2021V2.79729C3.86364 2.43652 4.16909 2.14253 4.54545 2.14253H12.7273V4.76158C12.7273 5.12301 13.032 5.41634 13.4091 5.41634H16.1364V17.2021C16.1364 17.5635 15.8309 17.8568 15.4545 17.8568H4.54545C4.16909 17.8568 3.86364 17.5635 3.86364 17.2021Z",
		fill: "currentColor"
	})
});
export default SvgDrafts;
